import React, { useEffect, useState } from 'react';
import { useAMedias } from '../../context/AMediasContext';
import { Download, X } from 'lucide-react';
import { guardarArchivo } from '../../utils/plataforma';

interface Props {
  planId: string;
  /** Para cargarlo de Firestore si no se pasa la imagen. */
  gastoId?: string;
  imagen?: string;
  titulo: string;
  onClose: () => void;
}

/** Foto de un ticket a pantalla completa. */
export const VisorTicket: React.FC<Props> = ({ planId, gastoId, imagen, titulo, onClose }) => {
  const { leerTicket } = useAMedias();
  const [src, setSrc] = useState<string | null | undefined>(imagen);

  useEffect(() => {
    if (imagen || !gastoId) return;
    leerTicket(planId, gastoId).then(setSrc).catch(() => setSrc(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId, gastoId, imagen]);

  return (
    <div className="fixed inset-0 z-[60] bg-black/90 flex flex-col seguro-arriba seguro-abajo" onClick={onClose}>
      <div className="flex items-center gap-2 px-4 py-3 text-white" onClick={e => e.stopPropagation()}>
        <p className="flex-1 font-semibold truncate">{titulo}</p>
        {src && (
          <button title="Descargar" aria-label="Descargar"
            onClick={() => guardarArchivo(`ticket-${titulo.replace(/[^\w-]+/g, '_')}.jpg`, src)
              .catch(e => console.error('No se pudo guardar el ticket', e))}
            className="p-2 rounded-lg hover:bg-white/10"><Download className="w-5 h-5" /></button>
        )}
        <button type="button" onClick={onClose} aria-label="Cerrar" className="boton-cerrar hover:bg-white/10"><X className="w-5 h-5" /></button>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 min-h-0">
        {src === undefined ? (
          <p className="text-white/70">Cargando…</p>
        ) : src === null ? (
          <p className="text-white/70">No se encontró la foto.</p>
        ) : (
          <img src={src} alt={`Ticket de ${titulo}`} className="max-w-full max-h-full object-contain"
            onClick={e => e.stopPropagation()} />
        )}
      </div>
    </div>
  );
};
